import { useQuery } from 'react-query'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { endpoints } from '@app/api/config'
import { ApiErrorResponse, CountryData, CountryDataResponse } from 'BackendApi'

const fetchCountries = async (): Promise<CountryData | undefined> => {
  const apiResponse = await apiAuthClient.get<CountryDataResponse>(
    endpoints.getCountries
  )
  return apiResponse.data.data
}

export const useGetCountries = () =>
  useQuery<CountryData | undefined, ApiErrorResponse>(
    ['getCountry'],
    fetchCountries
  )
